import { render, staticRenderFns } from "./SourceAffSubBlacklist.vue?vue&type=template&id=febe6b4e"
import script from "./SourceAffSubBlacklist.vue?vue&type=script&lang=js"
export * from "./SourceAffSubBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports